import ApiResourceManager from '../ApiResourceManager';

/**
 * Revenue-share settlements + the partner payout account, admin side: every
 * call is scoped on behalf of a partner via the header.
 */
export default class ProviderBillingSettlementsManager extends ApiResourceManager {
  #onBehalf = (serviceProviderId) =>
    serviceProviderId ? { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } } : {};

  index = (params = {}, serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: '/provider-billing/settlements',
      params,
      ...this.#onBehalf(serviceProviderId),
    });

  /** Manual retry — works regardless of the auto-settle ramp. */
  retry = (settlementId, serviceProviderId = undefined) =>
    this.request({
      method: 'POST',
      url: `/provider-billing/settlements/${settlementId}/retry`,
      ...this.#onBehalf(serviceProviderId),
    });

  payoutAccount = (serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: '/provider-billing/payout-account',
      ...this.#onBehalf(serviceProviderId),
    });

  createOnboardingLink = (data, serviceProviderId = undefined) =>
    this.request({
      method: 'POST',
      url: '/provider-billing/payout-account/onboarding-link',
      data,
      ...this.#onBehalf(serviceProviderId),
    });
}
